import { WorkflowTemplate } from "../types";
import WorkflowCard from "./WorkflowCard";

interface Props {
  workflows: WorkflowTemplate[];
  onUse: (workflow: WorkflowTemplate) => void;
}

export default function WorkflowGrid({ workflows, onUse }: Props) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
        gap: "24px",
        marginTop: "24px",
      }}
    >
      {workflows.map((workflow) => (
        <WorkflowCard key={workflow.id} workflow={workflow} onUse={onUse} />
      ))}
    </div>
  );
}
